<template>
  <div class="pt-10 mdmax:pt-6 px-6 mdmax:px-4 pb-20 body">
    <div class="flex mdmax:flex-col justify-between mdmax:justify-start items-center mdmax:items-stretch mb-4 mdmax:gap-4">
      <div class="relative w-1/3 mdmax:w-full">
        <TextField withIcon type="text" @input="searchCity($event, 'address')" v-model="addressSearch" :placeholder="$t('address.list.searchPlaceholder')" />
        <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
          <Search />
        </div>
        <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching" />
        <transition name="fade" mode="out-in">
          <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion">
            <ul v-if="cities" class="max-h-40 overflow-y-scroll">
              <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300 " v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city, 'origin')">
                {{ city.village }}, {{ city.area_display }}
              </li>
            </ul>
            <div class="py-4 text-center" v-else>
              {{ $t('address.dataNotFound') }}
            </div>
          </div>
        </transition>
      </div>

      <div class="w-1/6 mdmax:w-full">
        <Button :buttonText="$t('address.list.addAddress')" size="full" @action="addAddress()" />
      </div>
    </div>

    <div class="grid grid-cols-2 mdmax:grid-cols-1 gap-x-6">
      <div
        class="mb-5 last:mb-0 flex items-center bg-neutral-200 border border-neutral-300 rounded-md py-3 px-4 gap-3 cursor-pointer"
        v-for="(addr, index) in filteredAddresses"
        :key="'address-' + index"
        @click="modifyAddress(addr.id)"
      >
        <img :src="iconsMapping[addr.asset_icon_id]" v-if="iconsMapping[addr.asset_icon_id]" />
        <img src="@/assets/images/icons/home.svg" v-else />
        <div>
          <div class="flex gap-3 mb-1">
            <p class="font-medium text-sm ">{{ addr.location_label }}</p>
            <p class="text-xs text-neutral-500 bg-neutral-300 py-1 px-2 rounded-md" v-if="addr.is_main">Utama</p>
          </div>
          <p class="font-medium text-xs text-neutral-500 ellipsis" :title="addr.address">{{ addr.address }}, {{ addr.detail_address }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Button: () => import('@/components/Forms/Button'),
    Search: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Search'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField')
  },
  computed: {
    ...mapGetters('merchant', ['addresses', 'isAddressModalVisible']),
    filteredAddresses() {
      if (!this.addressSearch) return this.addresses
      return this.addresses.filter(addr => (addr.address + ' ' + addr.detail_address + ' ' + addr.location_label).toLowerCase().includes(this.addressSearch.toLowerCase()))
    }
  },
  data() {
    return {
      iconsMapping: {
        user: require('@/assets/images/icons/person.svg'),
        home: require('@/assets/images/icons/home.svg'),
        image: require('@/assets/images/icons/image.svg'),
        office: require('@/assets/images/icons/office.svg'),
        smile: require('@/assets/images/icons/smiled.svg'),
        star: require('@/assets/images/icons/star.svg'),
        heart: require('@/assets/images/icons/heart.svg'),
        basket: require('@/assets/images/icons/basket.svg')
      },
      addressSearch: '',
      isSearching: false,
      visibleSuggestion: false
    }
  },
  mounted() {
    this.getAddressInformation()
  },
  methods: {
    ...mapActions('merchant', ['getAddresses', 'toggleAddressModal']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    getAddressInformation() {
      this.showLoading()
      this.getAddresses({ params: '' }).then(() => this.hideLoading())
    },
    addAddress() {
      this.toggleAddressModal({
        state: !this.isAddressModalVisible,
        mode: 'ADD'
      })
      this.$emit('dismiss')
    },
    modifyAddress(addressId) {
      this.toggleAddressModal({
        state: !this.isAddressModalVisible,
        mode: 'EDIT',
        addressId: addressId
      })
      this.$emit('dismiss')
    }
  }
}
</script>
<style lang="scss" scoped>
.body {
  height: calc(100vh - 52px);
  overflow-y: scroll;
}

.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  height: 16px;
  word-break: break-all;
}
</style>
